import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row flex-wrap wrap justify-center" }
const _hoisted_2 = { class: "max-w-lg w-64 lg:max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center" }
const _hoisted_6 = { class: "max-w-lg w-64 lg:max-w-xs" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_8 = { class: "relative text-gray-600 focus-within:text-gray-600" }
const _hoisted_9 = { class: "pointer-events-none absolute inset-y-0 pl-1 left-0 flex items-center" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateSelector',
  emits: ["search"],
  setup(__props, { expose }) {

const state = ref({ from: null, to: null });

expose({
  state,
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("messages.summaryReport.from")) + " : ", 1),
        _withDirectives(_createElementVNode("input", {
          id: "from",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value.from) = $event)),
          maxlength: "10",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search', state.value))),
          class: "block w-full bg-white py-2 pl-16 md:pl-14 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
          placeholder: "From",
          type: "date",
          name: "from"
        }, null, 544), [
          [_vModelText, state.value.from]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("messages.summaryReport.to")) + ": ", 1),
        _withDirectives(_createElementVNode("input", {
          id: "from",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.value.to) = $event)),
          maxlength: "10",
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('search', state.value))),
          class: "block w-full bg-white py-2 pl-16 md:pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
          placeholder: "To",
          type: "date",
          name: "to"
        }, null, 544), [
          [_vModelText, state.value.to]
        ])
      ])
    ])
  ]))
}
}

})